export default "__VITE_ASSET__BgO0UBvC__"